import { DEFAULT_STUDENT, PCHANNEL_TITLE } from "./constant/constants";

/**
 * The `formatCurrency` function formats a number as Vietnamese Dong currency (VND) with a maximum of 0
 * decimal places and a maximum of 13 significant digits.
 * @param number - The `number` parameter is the value that you want to format as currency. It can be
 * any numerical value.
 * @returns The function `formatCurrency` returns a formatted string representing the given number in
 * Vietnamese Dong (VND) currency format.
 */
export function formatCurrency(number, showCurrencySymbol = true) {
  if (!number) return showCurrencySymbol ? "0 VND" : "0";

  const formatter = new Intl.NumberFormat("vi-VN", {
    style: showCurrencySymbol ? "currency" : "decimal", // Use 'currency' if showCurrencySymbol is true, otherwise use 'decimal'
    currency: "VND",
    currencyDisplay: "code",
    useGrouping: true,
    maximumFractionDigits: 0,
    // maximumSignificantDigits: 13,
  });

  return formatter.format(number).replace(/\./g, ",");
}

export function reverseFormatCurrency(formattedNumber) {
  return parseInt(formattedNumber.replace(/,/g, ""), 10);
}

export const getSubDomain = () => {
  let subDomain = window.location.host.split(".")[0];
  if (window.location.host.split(".")) {
    if (process.env.NODE_ENV === "development") {
      //   subDomain = "atom-m-75-mms"
    }
    return subDomain;
  }
  return null;
};

export const getStatus = (status) => {
  switch (status.toLowerCase()) {
    case "success":
      return "report_status_success";
    case "fail":
      return "report_status_fail";
    case "pending":
      return "report_status_pending";
    case "PAID":
      return "Paid";
    case "WAITING_FOR_PAID":
      return "Waiting";
    default:
      return "";
  }
};

export const handleToastErr = (key) => {
  if (key === "name") return "Vui lòng nhập tên đăng nhập";
  if (key === "password") return "Vui lòng nhập mật khẩu";
  if (key === "bank_code") return "Vui lòng chọn ngân hàng";
  if (key === "tax_no") return "Mã số thuế không tồn tại";
  if (key === "channel-name") return `Vui lòng nhập tên ${PCHANNEL_TITLE}`;
  if (key === "prefix") return "Vui lòng nhập tiền tố đơn hàng";
  // if (key === 'prefix') return 'Vui lòng nhập tiền tố đơn hàng';
  return false;
};

export const formatBankAccount = (accountNumber) => {
  if (accountNumber?.length < 4) return accountNumber;

  const lastFourDigits = accountNumber?.slice(-4);
  return "***" + lastFourDigits;
};

export const formatVaType = (vaType) => {
  if (!vaType) return "";
  if (vaType == "STORE") return "shop_qr_management_shop_branch";
  if (vaType == "STAFF") return "shop_qr_management_staff";
  if (vaType == "BILL") return "shop_qr_management_add_bill";
};

export const formatChannel = (channel) => {
  if (!channel) return "";
  if (channel == "WEBSITE") return "Website";
  if (channel == "KIOSK") return "Kiosk";
  if (channel == "MOBILE") return "Mobile";
  if (channel == "IN_STORE") return "shop_qr_management_at_counter";
  if (channel == "CALL_CENTER") return "Call center";
};

export const formatPaymentMethod = (methodCode) => {
  if (typeof methodCode != "number") return " ";
  switch (methodCode) {
    case 0:
      return "sell_management_qrCode";
    case 1:
      return "sell_management_cash";
    case 2:
      return "sell_management_card_payment";
    default:
      break;
  }
  //return methodCode == 0 ? 'QR' : methodCode == 1 ? 'Tiền mặt' : 'Thanh toán thẻ'
};

export const getCardTypeLogo = (cardType) => {
  const card = cardType.toString().toLowerCase();
  return `/images/card-type/${card || "master"}.svg`;
};

export const formatName = (fullname) => {
  if (!fullname) return "";
  if (fullname.includes(",")) {
    const resultArray = String(fullname)?.split(", ");
    return resultArray[1];
  }
  return fullname;
};

export const formatDateFromDate = (value) => {
  if (!value) return "";
  const arr = value?.toString()?.split("-");
  return arr?.reverse()?.join("/");
};

export const formatDate = (value) => {
  if (!value) return "";
  const millisecondDate = formatDateToMilliseconds(value); // Ex: Mon Nov 04 2024 00:00:00 GMT+0700 (Indochina Time) to 1727370000 (Milliseconds)
  const date = formatDateFromMilliseconds(millisecondDate); // Ex: 1727370000 (Milliseconds) to 27/09/2024

  return date.toString().split("/").reverse().join("-");
};

export const formatDateFromMilliseconds = (milliseconds) => {
  const d = new Date(milliseconds * Math.pow(10, 3));
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  return d.toLocaleDateString("vi-VN", options);
};

export const formatDateToMilliseconds = (date) => {
  return Date.parse(date) / Math.pow(10, 3);
};

export const formatDateTxn = (value, hasHHMM = true) => {
  const [date, time] = value.split(" ");
  // const arr = date?.split("-");
  // return arr?.reverse()?.join("/");
  const newDate = date.split("-").reverse().join("/");
  const [h, m, s] = time.split(":");
  if (hasHHMM) return newDate + " " + h + ":" + m;
  return newDate;
};

export function getDaysDifference(date1, date2) {
  // Create Date objects for the input dates
  const startDate = new Date(date1);
  const endDate = new Date(date2);

  // Calculate the time difference in milliseconds
  const timeDifference = endDate - startDate;

  // Convert the time difference to days
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  return daysDifference.toString();
}

export const getToday = () => {
  let currentDate = new Date();
  // Set the start of the day (0:00:00)
  let startOfDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    0,
    0,
    0,
    0
  );
  // Set the end of the day (23:59:59)
  let endOfDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    23,
    59,
    59,
    999
  );

  return [startOfDay, endOfDay];
};

export const getYesterday = () => {
  let currentDate = new Date();

  // Set the start of yesterday (0:00:00)
  let startOfYesterday = new Date(currentDate);
  startOfYesterday.setDate(currentDate.getDate() - 1);
  startOfYesterday.setHours(0, 0, 0, 0);

  // Set the end of yesterday (23:59:59)
  let endOfYesterday = new Date(currentDate);
  endOfYesterday.setDate(currentDate.getDate() - 1);
  endOfYesterday.setHours(23, 59, 59, 999);

  return [startOfYesterday, endOfYesterday];
};

export const getSevenDayAgo = () => {
  let currentDate = new Date();

  // Set the start of 7 days ago (0:00:00)
  let startOf7DaysAgo = new Date(currentDate);
  startOf7DaysAgo.setDate(currentDate.getDate() - 7);
  startOf7DaysAgo.setHours(0, 0, 0, 0);

  // Set the start of 7 days ago (0:00:00)
  let endOf7DaysAgo = new Date(currentDate);
  startOf7DaysAgo.setDate(currentDate.getDate() - 7);
  endOf7DaysAgo.setHours(23, 59, 59, 999);

  return [startOf7DaysAgo, endOf7DaysAgo];
};

export const getThisMonth = () => {
  let currentDate = new Date();

  // Set the start of the first day of the current month (0:00:00)
  let firstDayOfCurrentMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  firstDayOfCurrentMonth.setHours(0, 0, 0, 0);

  // Set the end of today (23:59:59)
  let endOfToday = new Date(currentDate);
  endOfToday.setHours(23, 59, 59, 999);
  return [firstDayOfCurrentMonth, endOfToday];
};

export const getLastMonth = () => {
  let currentDate = new Date();

  // Set the start of the first day of the last month (0:00:00)
  let firstDayOfLastMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    1
  );
  firstDayOfLastMonth.setHours(0, 0, 0, 0);

  // Set the end of the last day of the last month (23:59:59)
  let lastDayOfLastMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    0
  );
  lastDayOfLastMonth.setHours(23, 59, 59, 999);

  return [firstDayOfLastMonth, lastDayOfLastMonth];
};

export const getThisQuarter = () => {
  let currentDate = new Date();
  // Determine the current quarter
  const currentQuarter = Math.floor((currentDate.getMonth() + 3) / 3);

  // Set the start of the first day of the current quarter (0:00:00)
  let firstDayOfCurrentQuarter = new Date(
    currentDate.getFullYear(),
    (currentQuarter - 1) * 3,
    1
  );
  firstDayOfCurrentQuarter.setHours(0, 0, 0, 0);

  return [firstDayOfCurrentQuarter, currentDate];
};

export const isValidPhoneNumber = (p) => {
  const phoneRe = /(84|0[3|5|7|8|9])+([0-9]{8})\b/;
  const digits = p.replace(/\D/g, "");
  return phoneRe.test(digits);
};

export const hasTuitionPayer = (student) => {
  if (!student || student === DEFAULT_STUDENT) return false;
  return true;
};

export const convertToGMTPlus7 = (dateTimeString) => {
  const [datePart, timePart] = dateTimeString.split(" ");
  const [year, month, day] = datePart.split("-");
  const [hour, minute, second] = timePart.split(":");

  // Tạo đối tượng Date với múi giờ UTC
  const date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));

  // Thêm 7 giờ để chuyển sang múi giờ GMT+7
  date.setUTCHours(date.getUTCHours() + 7);

  // Định dạng lại thành chuỗi
  const pad = (num) => num.toString().padStart(2, "0");

  return `${date.getUTCDate()}-${pad(date.getUTCMonth() + 1)}-${pad(
    date.getUTCFullYear()
  )} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(
    date.getUTCSeconds()
  )}`;
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  if (phoneNumber.startsWith("+84")) return "0" + phoneNumber.substring(3);
  if (phoneNumber.startsWith("84")) return "0" + phoneNumber.substring(2);
  return phoneNumber;
};

export const compareDateTime = (input, payment_state, state) => {
  const inputDate = new Date(input);
  const options = {
    timeZone: "Asia/Bangkok",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  inputDate.setHours(inputDate.getHours() + 14);

  const formattedDate = new Date(inputDate.toLocaleString("en-US", options))
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");

  if (
    new Date(formattedDate) < currentDate &&
    (payment_state === "not_paid" || payment_state === "partial")
  ) {
    return true;
  } else return false;
};
